import { Component, Input } from '@angular/core';
import { CountUpDirective } from '../../directives/count-up.directive';
import { CommonModule, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-performance-card',
  standalone: true,
  imports: [CountUpDirective, CommonModule, CurrencyPipe],
  templateUrl: './performance-card.component.html',
  styleUrl: './performance-card.component.scss'
})
export class PerformanceCardComponent {


  _count = 0;
  _name = ''
  @Input() set name(value: string) {
    console.log("name", value);
    this._name = value
  }
  get name() {
    return this._name;
  }

  @Input() set count(value: number) {
    console.log("count", value);
    this._count = value
  }
  get count() {
    return this._count;
  }


  @Input() type = ""
  @Input() icon = ""

}
